import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

// components
import AttributeLink from './helpers/AttributeLink';

// helpers
import get from 'lodash.get';

function PdpSharedDetailMaterialsAndTechniques(props) {
    const categories = get(props, 'item.classification.categories');
    const materialsAndTechniques = get(props, 'item.attributes.techniqueMaterialGroup') || [];

    if (!materialsAndTechniques.length) {
        return null;
    }
    return (
        <span data-tn="pdp-spec-materials-and-techniques">
            {materialsAndTechniques.map((group, index) => {
                const attribute1 = get(group, 'items[0]');
                const attribute2 = get(group, 'items[1]');
                return (
                    <span key={`${attribute1.groupKey}-${index}`}>
                        {/* delimiter */}
                        {index > 0 && ', '}
                        {!!attribute1 && (
                            <AttributeLink attribute={attribute1} categories={categories} />
                        )}
                        {!!attribute2 && ' '}
                        {!!attribute2 && (
                            <AttributeLink attribute={attribute2} categories={categories} />
                        )}
                    </span>
                );
            })}
        </span>
    );
}

PdpSharedDetailMaterialsAndTechniques.propTypes = {
    item: PropTypes.object.isRequired,
};

export default createFragmentContainer(PdpSharedDetailMaterialsAndTechniques, {
    item: graphql`
        fragment PdpSharedDetailMaterialsAndTechniques_item on Item {
            classification {
                categories {
                    precedence
                    category {
                        browseUrl
                    }
                }
            }
            attributes {
                techniqueMaterialGroup {
                    items {
                        groupKey
                        attributeKey
                        publishedItemsCount
                        option {
                            name
                            urlLabel
                        }
                    }
                }
            }
        }
    `,
});
